import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { NeuroMessage } from '@ignitesales/neuro-application/src/neuro-guide';
import { useNeuroMessages } from '@ignitesales/neuro-application/src/neuro-guide/components/MessageContext';
import { Modal } from '@ignitesales/neuro-application/src/neuro-ui/index';
import { useUser } from '@ignitesales/neuro-application/src/neuro-guide/hooks';
import * as analytics from  "../../utils/analytics";

  const SuccessFormModal = ({ className, closeBtn, isOpen, onClose, onSuccessModalClose, selectedProduct, ...rest }) => {
  const messageContext = useNeuroMessages();
  const classes = classnames(className, 'successFormModal contactFormModal');

  const defaultSuccessHeader = messageContext.getMessage('success.default.header');

  const openAccountSuccessHeader = messageContext.getMessage('success.openAccount.header');
  const openAccountSuccessMessage = messageContext.getMessage('success.openAccount.message');
  const openAccountSuccessButton = messageContext.getMessage('success.openAccount.button');

  const contactLoanTeamSuccessMessage = messageContext.getMessage('success.contactLoanTeam.message');
  const contactLoanTeamSuccessButton = messageContext.getMessage('success.contactLoanTeam.button');

  const contactUsSuccessMessage = messageContext.getMessage('success.contactUs.message');
  const contactUsSuccessButton = messageContext.getMessage('success.contactUs.button');

  const educationResourcesSuccessMessage = messageContext.getMessage('success.educationResources.message');
  const educationResourcesSuccessButton = messageContext.getMessage('success.educationResources.button');

  const productActionLogic = ['4', '5'].includes(selectedProduct.productAction);

  const { uuid } = useUser();

  const onModalClose = () => {
    onSuccessModalClose();
  };

  const onBeginApp = () => {
    const productUrl  = selectedProduct.productUrl;

    analytics.processEvent({ event: 'startApp', data: { productUrl } });
   };

  const successHeader = productActionLogic ? defaultSuccessHeader : openAccountSuccessHeader;
  let successMessage, successButtonText, successButton;

  switch (selectedProduct.productAction) {
    case '4':
      successMessage = contactLoanTeamSuccessMessage;
      successButtonText = contactLoanTeamSuccessButton;
      successButton = <a href="tel:715-833-7251" className='btn btn-primary'><NeuroMessage id={contactLoanTeamSuccessButton} /></a>;
      break;
    case '5':
      successMessage = contactUsSuccessMessage;
      successButtonText = contactUsSuccessButton;
      successButton = <a href="tel:800-341-9911" className='btn btn-primary'><NeuroMessage id={contactUsSuccessButton} /></a>;
      break;
    case '6':
      successMessage = educationResourcesSuccessMessage;
      successButtonText = educationResourcesSuccessButton;
      successButton = <a href={selectedProduct.productUrl} target="_blank" onClick={onModalClose} className='btn'><NeuroMessage id={educationResourcesSuccessButton} /></a>;
      break;
    default:
      successMessage = openAccountSuccessMessage;
      successButtonText = openAccountSuccessButton;
      successButton = <a href="#" onClick={onBeginApp} className='btn'><NeuroMessage id={openAccountSuccessButton} /></a>;
  }

  return (
    <Modal
      show={ isOpen }
      className={ classes }
      title={ successHeader }
      onClose={ onClose }
      closeBtn={ closeBtn }
      nodeId="root"
    >


      <div className="shareResults">
        { selectedProduct.productAction == '4' || selectedProduct.productAction == '5' ? <NeuroMessage id="uuidMessage" values={ { uuid } } tagName='p' /> : null }
        <NeuroMessage id={ successMessage } tagName='p' />
        { selectedProduct.productAction == '4' ? <NeuroMessage id="success.contactLoanTeam.messageTwo" tagName='span' /> : selectedProduct.productAction == '5' ? <NeuroMessage id="success.contactUs.messageTwo" tagName='span' /> : null }
        <div onClick={ onSuccessModalClose }>
          { successButton }
        </div>
      </div>

    </Modal>
  );
};
SuccessFormModal.propTypes = {
  className: PropTypes.string,
  closeBtn: PropTypes.any,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};

export default SuccessFormModal;
